<template>
  <div>
    <v-dialog v-model="documentModal" max-width="500px">
      <PopsManageDocumentInfra
        :documentId="selectedDocument.id"
        :parentFolderId="selectedFolderId"
        @close="documentModal = false"
        @success="reloadDataKeepingState"
        :key="documentDialogKey"
      />
    </v-dialog>

    <v-dialog v-model="folderModal" max-width="500px">
      <PopsManageFolderInfra
        :folderId="selectedFolderId"
        :parentFolderId="parentFolderId"
        @close="folderModal = false"
        @success="reloadDataKeepingState"
        :key="folderDialogKey"
      />
    </v-dialog>

    <div
      v-if="!loading && specificFolder.length > 0"
      class="my-folder-list"
      ref="subFolderList"
    >
      <v-expansion-panels v-model="panel" multiple>
        <DragDiv
          :list="specificFolder"
          group="common-sub-folder-items"
          ghost-class="ghost"
          animation="200"
          style="width: 100%"
          draggable=".my-list-common-sub-folder-items"
          @change="ChangeOrder"
          tag="div"
        >
          <v-expansion-panel
            v-for="(item, i) in specificFolder"
            :key="item.id || i"
            :readonly="item.isDocument"
            class="my-list-common-sub-folder-items"
          >
            <v-expansion-panel-header
              :hide-actions="item.isDocument"
              :style="`${item.isDocument ? 'cursor: default' : ''}`"
            >
              <div
                v-if="item.isDocument"
                class="d-flex justify-center"
                style="max-width: 20px; margin-top: -6px"
              >
                <v-checkbox
                  class="mr-1"
                  dense
                  small
                  v-model="item.selected"
                  hide-details
                  @click="addToDownloadList(item)"
                ></v-checkbox>
              </div>
              <span
                v-if="item.isDocument"
                style="margin-bottom: -4px; margin-left: 6px"
              >
                <v-icon class="pr-2" style="margin-top: -3px">
                  mdi-file-document-outline
                </v-icon>
                <span class="font-weight-medium pt-2">{{ item.name }}</span>
              </span>
              <span v-else>
                <v-icon class="pr-2" style="margin-top: -3px">
                  mdi-folder-outline
                </v-icon>
                <span class="font-weight-medium pt-2">{{ item.name }}</span>
              </span>
              <div
                :style="`display: flex; justify-content: flex-end; ${
                  item.isDocument ? 'margin-right: 32px' : 'margin-right: 12px'
                }`"
              >
                <span>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        class="ma-1"
                        small
                        depressed
                        color="primary"
                        @click.stop="
                          item.isDocument
                            ? editDocument(item)
                            : updateFolder(item)
                        "
                        v-if="user.mainType == 0 || user.mainType == 1"
                      >
                        <v-icon small color="#f5f5f5">
                          mdi-pencil-outline
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>Editar</span>
                  </v-tooltip>

                  <v-menu v-if="!item.isDocument" offset-y>
                    <template v-slot:activator="{ on }">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on: tooltipOn }">
                          <v-btn
                            class="ma-1"
                            small
                            depressed
                            color="primary"
                            v-on="{ ...on, ...tooltipOn }"
                            v-if="user.mainType == 0 || user.mainType == 1"
                          >
                            <v-icon small color="#f5f5f5">mdi-plus</v-icon>
                          </v-btn>
                        </template>
                        <span>Adicionar</span>
                      </v-tooltip>
                    </template>
                    <v-list nav dense>
                      <v-list-item-group
                        active-class="info--text text--accent-2"
                      >
                        <v-list-item
                          v-for="(actionItem, index) in addTableItems"
                          :key="index"
                          @click.stop="actionItem.action(item)"
                          width="100%"
                        >
                          <v-list-item-icon class="mr-2">
                            <v-icon>{{ actionItem.icon }}</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title>{{
                            actionItem.title
                          }}</v-list-item-title>
                        </v-list-item>
                      </v-list-item-group>
                    </v-list>
                  </v-menu>

                  <v-tooltip v-if="item.isDocument" bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        class="ma-1"
                        small
                        depressed
                        color="primary"
                        @click.stop="getFile(item)"
                      >
                        <v-icon small color="#f5f5f5">mdi-open-in-new</v-icon>
                      </v-btn>
                    </template>
                    <span>Abrir documento</span>
                  </v-tooltip>

                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        class="ma-1"
                        small
                        depressed
                        color="#ff4f64"
                        v-if="user.mainType == 0 || user.mainType == 1"
                        @click.stop="
                          item.isDocument
                            ? deleteDocument(item)
                            : deleteFolder(item)
                        "
                      >
                        <v-icon small color="#f5f5f5"
                          >mdi-trash-can-outline</v-icon
                        >
                      </v-btn>
                    </template>
                    <span>Excluir</span>
                  </v-tooltip>
                </span>
              </div>
            </v-expansion-panel-header>

            <v-expansion-panel-content>
              <PopsSecondSubFolderInfra
                v-if="!item.isDocument"
                :folder="item"
                @edit-document="editDocument"
                @update-folder="updateFolder"
                @get-file="getFile"
                @delete-document="deleteDocument"
                @delete-folder="deleteFolder"
                @add-to-download-list="addToDownloadList"
                @open-add-doc-modal="openAddDocModal"
              />
            </v-expansion-panel-content>
          </v-expansion-panel>
        </DragDiv>
      </v-expansion-panels>

      <v-card v-if="totalPages > 1" v-intersect="getMoreData"> </v-card>
    </div>

    <div
      v-else-if="!loading && specificFolder.length === 0"
      class="text-center pa-4"
    >
      <span>Esta pasta está vazia</span>
    </div>
  </div>
</template>

<script>
import ApiService from '../../../../../services/ApiService'
import PopsSecondSubFolderInfra from './PopsSecondSubFolderInfra.vue'
import PopsManageDocumentInfra from '../PopsManageDocumentInfra.vue'
import PopsManageFolderInfra from '../PopsManageFolderInfra.vue'

export default {
  name: 'PopsSubFolder',

  components: {
    PopsSecondSubFolderInfra,
    PopsManageDocumentInfra,
    PopsManageFolderInfra,
  },

  props: {
    folder: Object,
    index: Number,
    addTableItems: Array,
  },

  data() {
    return {
      pageSize: 10,
      page: 1,
      sizes: [10, 30, 90, 180],
      totalItems: null,
      totalItensOnPage: 1,
      totalPages: null,
      apiService: new ApiService(),
      specificFolder: [],
      filterListFolderWithDoc: {
        institutionId: null,
        page: 1,
        pageSize: 10,
      },
      loading: false,
      user: {},
      documentModal: false,
      folderModal: false,
      documentDialogKey: false,
      folderDialogKey: false,
      selectedDocument: {},
      selectedFolderId: null,
      parentFolderId: null,
      panel: [],
      isReordering: false,
    }
  },

  watch: {
    folder() {
      this.reloadDataKeepingState()
    },

    pageSize() {
      this.filterListFolderWithDoc.pageSize = this.pageSize
      this.filterListFolderWithDoc.page = 1
      this.getSpecificFolder(this.folder)
    },

    page() {
      this.filterListFolderWithDoc.page = this.page
      this.getSpecificFolder(this.folder)
    },
  },

  created() {
    this.user = JSON.parse(localStorage.getItem('user'))
    this.getSpecificFolder(this.folder)
  },

  methods: {
    async getMoreData(entries, observer, previous) {
      if (entries[0].isIntersecting && !this.isReordering) {
        this.filterListFolderWithDoc.page++

        if (this.filterListFolderWithDoc.page <= this.totalPages) {
          const initialHeight = this.$refs.subFolderList.scrollHeight
          this.filterListFolderWithDoc.folderId = this.folder.id

          try {
            const response = await this.apiService.get(
              `PopDocumentFolder/list-with-doc-infra`,
              this.filterListFolderWithDoc
            )

            const newItems = response.content.data.map((item, index) => ({
              ...item,
              order: this.specificFolder.length + index,
            }))

            this.specificFolder.push(...newItems)

            this.$nextTick(() => {
              setTimeout(() => {
                this.$refs.subFolderList.scrollTop = initialHeight
              }, 100)
            })
          } catch (error) {
            console.error('Erro ao carregar dados da pasta:', error)
          }
        }
      }
    },

    async reloadDataKeepingState() {
      const panel = [...this.panel]
      await this.getSpecificFolder(this.folder)

      await this.$nextTick()
      this.panel = panel

      this.documentModal = false
      this.folderModal = false
    },

    async ChangeOrder(event) {
      if (event.moved) {
        this.isReordering = true
        const findItem = event.moved.element
        const newIndex = event.moved.newIndex
        const oldIndex = event.moved.oldIndex

        console.log(
          'Movendo item:',
          findItem.name,
          'de',
          oldIndex,
          'para',
          newIndex
        )

        findItem.order = newIndex

        this.specificFolder.forEach((item, index) => {
          if (item.id !== findItem.id) {
            item.order = index
          }
        })

        try {
          if (findItem.filePath || findItem.isDocument) {
            await this.updateDocOrder(findItem)
            console.log('Documento reordenado:', findItem.name)
          } else {
            await this.updateFolderOrder(findItem)
            console.log('Pasta reordenada:', findItem.name)
          }
        } catch (error) {
          console.error('Erro ao atualizar ordem:', error)

          await this.reloadDataKeepingState()
        } finally {
          this.isReordering = false
        }
      }
    },

    async updateDocOrder(item) {
      const model = {
        entityId: item.id,
        order: item.order,
        folderId: this.folder.id,
      }

      console.log('Atualizando ordem do documento:', model)
      return this.apiService.post('PopDocument/change-order', model)
    },

    async updateFolderOrder(item) {
      const model = {
        entityId: item.id,
        order: item.order,
        parentFolderId: this.folder.id,
      }

      console.log('Atualizando ordem da pasta:', model)
      return this.apiService.post('PopDocumentFolder/change-order', model)
    },

    async getSpecificFolder(folder) {
      if (!folder || !folder.id) return

      this.filterListFolderWithDoc.folderId = folder.id
      this.filterListFolderWithDoc.page = 1
      this.loading = true

      try {
        const response = await this.apiService.get(
          `PopDocumentFolder/list-with-doc-infra`,
          this.filterListFolderWithDoc
        )

        this.specificFolder = response.content.data.map((item, index) => ({
          ...item,
          order: item.order !== undefined ? item.order : index,
        }))

        this.totalPages = response.content.pager.totalPages
        this.totalItems = response.content.pager.totalItems
        this.loading = false
      } catch (error) {
        this.loading = false
        console.error('Erro ao carregar dados da pasta:', error)
      }
    },

    editDocument(item) {
      this.documentDialogKey = !this.documentDialogKey
      this.selectedDocument = { ...item }
      this.documentModal = true
    },

    updateFolder(item) {
      this.folderDialogKey = !this.folderDialogKey
      this.selectedFolderId = item.id
      this.parentFolderId = item.folderId
      this.editFolderMode = true
      this.folderModal = true
    },

    getFile(item) {
      this.$emit('get-file', item)
    },

    deleteDocument(item) {
      this.$emit('delete-document', item)
    },

    deleteFolder(item) {
      this.$emit('delete-folder', item)
    },

    addToDownloadList(item) {
      this.$emit('add-to-download-list', item)
    },

    openAddFolderModal(item) {
      this.folderDialogKey = !this.folderDialogKey
      this.selectedFolderId = null
      this.parentFolderId = item ? item.id : this.folder.id
      this.folderModal = true
    },

    openAddDocModal(item) {
      this.selectedDocument = {}
      this.selectedFolderId = item ? item.id : this.folder.id
      this.documentDialogKey = !this.documentDialogKey
      this.documentModal = true
    },
  },
}
</script>

<style scoped>
.ghost {
  opacity: 0.5;
}

.my-folder-list {
  max-height: 400px;
  overflow-y: auto;
}

.my-folder-list::-webkit-scrollbar {
  background-color: #f9f9f9;
  width: 8px;
  border-radius: 20px;
}

.my-folder-list::-webkit-scrollbar-thumb {
  background: #e1e1e1;
  border-radius: 3.5px;
}

.topper-espansion-title {
  color: #fff;
  font-size: 11px;
  font-weight: 600;
  line-height: 14px;
  overflow-wrap: break-word;
  text-align: center;
}

.v-expansion-panel-header {
  padding-block: 8px !important;
}
</style>
